// src/services/stripe.js
import { getFunctions, httpsCallable } from "firebase/functions";
import app from "./firebase";

// Utiliser onCall avec httpsCallable — Firebase gère le CORS automatiquement
const functions = getFunctions(app, "europe-west1");

export async function creerSessionPaiement({ orgId, tombolaId, tombolaName }) {
  const createCheckoutSession = httpsCallable(functions, "createCheckoutSession");
  const result = await createCheckoutSession({ orgId, tombolaId, tombolaName });
  return result.data;
}
